import type { EditorAPI } from '#packages/editorAPI';
import type { MobileBlockReparentingApi } from '#packages/mobileBlockReparenting/api';
import type { layoutTransitionsUtil } from '#packages/layoutUtils';
import type { CompLayout, CompRef } from 'types/documentServices';
import type { OptimisticDragHandler } from './optimisticDragHandlerThunderbolt';
import type { MousePosition } from '../../types';
import type { SlotOpenerApi } from '#packages/slotOpener';

export interface DragMoveToScope {
  editorAPI: EditorAPI;
  mobileBlockReparentingApi: MobileBlockReparentingApi;
  slotOpenerApi: SlotOpenerApi;
  selectedComp: CompRef[];
  isHorizontallyMovable: boolean;
  isVerticallyMovable: boolean;
  considerParentLayoutChange: boolean[];
  initMousePosition: MousePosition;
  dragTransition: layoutTransitionsUtil.Drag;
  initialCompLayout: CompLayout;
  optimisticDragHandler: OptimisticDragHandler;
  initCompLayoutsRelativeToScreen: CompLayout[];
  initCompLayouts: CompLayout[];
}

export interface DragMoveToInterceptionScope {
  editorAPI: EditorAPI;
  compRefs: CompRef[];
  mousePositionInitial: MousePosition;
}

export interface DragMoveToInterceptionResult {
  isHandled: boolean;
}
